"use strict";

/*global firebase firebaseui*/
/*eslint no-undef: "error"*/

function init() {
	const pageKey = window.location.pathname.split('/').filter( p => p).join("_");
	const pageHitKey = `${pageKey}/hits`;
	const pageLikeKey = `${pageKey}/likes`;
	const pageCommentKey = `${pageKey}/comments`;
	const bstr = "eyJhcGlLZXkiOiJBSXphU3lEbUI2VEhab3lCSXV5emYwM2NBTUY2MFZLZGZTLXJYVjAiLCJhdXRoRG9tYWluIjoid2VjaGluZXNlLWQzYTVkLmZpcmViYXNlYXBwLmNvbSIsImRhdGFiYXNlVVJMIjoiaHR0cHM6Ly93ZWNoaW5lc2UtZDNhNWQuZmlyZWJhc2Vpby5jb20ifQ==";
	let curUser = null;

	function _readSetHitCounter() {
		let counterBase = firebase.database().ref(pageHitKey);
		counterBase.on('value', snapshot => $('#hitCounter').text(snapshot.val() || "") );

		if (!localStorage[pageHitKey]) {
			counterBase.transaction(current_value => {
				localStorage[pageHitKey] = true;
				return (current_value || 0) + 1;
			});
		}
	}

	function _readHandleLikeCounter() {
		let likeBase = firebase.database().ref(pageLikeKey);
		likeBase.on('value', snapshot => $('#likeCounter').text( snapshot.val() || "") );

		function _showLikeCounted() {
			$('.counter-n-like').removeClass('show-pointer');
			$(".glyphicon.glyphicon-thumbs-up").addClass('counted');
			localStorage[pageLikeKey] = true;
		}

		if (!localStorage[pageLikeKey]) {
			$('.counter-n-like').one("click", function () {
				likeBase.transaction(current_value => (current_value || 0) + 1);
				_showLikeCounted();
			});
		}
		else {
			_showLikeCounted();
		}
	}

	function _enableButtons(toEnable) {
		$(".modal-footer > .btn").prop("disabled", !toEnable);
		let spinner = $('.modal-footer > .btn > .glyphicon.spinning') ;
		toEnable ? spinner.hide() : spinner.show();
	}

	function _popupSignIn() {
		let uiConfig = {
			signInOptions: [
				firebase.auth.EmailAuthProvider.PROVIDER_ID
			],
			credentialHelper: firebaseui.auth.CredentialHelper.NONE,
			callbacks: {
				signInSuccess: function(currentUser, credential, redirectUrl) {
					curUser = currentUser;
					setTimeout(_popupNewComment, 100);
					return false;
				}
			},
			tosUrl: 'http://wechineseinus.com/about/'
		};

		let ui = new firebaseui.auth.AuthUI(firebase.auth());
		ui.start('#firebaseui-auth-container', uiConfig);
	}

	function _popupNewComment() {
		let newCommentModal = $('#newCommentModal');
		newCommentModal.on('show.bs.modal', function (e) {
			_enableButtons(true);

			$('#logoutBtn').on('click', _logout);
			$('#submitCommentBtn').on('click', _postComment);

			$('#userDisplayName').val(curUser.displayName);
			$('#commentBody').val("");
			$('#error-msg').text("");
		});

		newCommentModal.on('hide.bs.modal', function (e) {
			$('#logoutBtn').off('click', _logout);
			$('#submitCommentBtn').off('click', _postComment);
		});

		newCommentModal.modal('show');
	}

	function _logout() {
		firebase.auth().signOut().then(function() {
			$('#newCommentModal').modal('hide');
		}, function(error) {
			console.error(error);
		});
	}

	function _postComment() {
		_enableButtons(false);
		$('#error-msg').text("");

		let commentBody = $('#commentBody').val().trim();
		let displayName = $('#userDisplayName').val().trim();
		if (!commentBody || !displayName) {
			$('#error-msg').text("請填入用戶筆名和評論內容");
			if (!displayName) {
				$('#userDisplayName').focus();
			}
			else if (!commentBody) {
				$('#commentBody').focus();
			}
			_enableButtons(true);
			return;
		}

		if (displayName !== curUser.displayName) {
			curUser.updateProfile({
				displayName: displayName
			}).then(function() {
				console.log("displayName is updated to:", displayName);
			}, function(error) {
				console.error("displayName is failed to update", displayName);
			});
		}

		firebase.database().ref(pageCommentKey).push().set({
			user_id: curUser.uid,
			user: displayName,
			comment: commentBody,
			timestamp: new Date().toISOString()
		});

		$('#newCommentModal').modal('hide');
	}

	function _localeDateFromUTC(isoStr) {
		let s = isoStr.split(/[\-\.\+: TZ]/g);
		let dateObj = new Date(Date.UTC(+s[0], --s[1], +s[2], +s[3], +s[4], +s[5], 0));
		return dateObj.toLocaleString().replace(",", " ");
	}

	function _createOneComment(data) {
		let datetime = _localeDateFromUTC(data.timestamp);
		return `<div class="panel panel-default">
					<div class="panel-heading">
						<h3 class="panel-title comment-title">${data.user}</h3>
						<span class="comment-subtitle">發表評論於 </span> <span class="comment-timestamp">${datetime}</span>
					</div>
					<div class="panel-body">${data.comment}</div>
				</div>`;
	}

	function _readHandleComments() {
		let comments = $('.comments-list');
		let commentCounter = $('#commentCounter');
		let counter = 0;

		let commentBase = firebase.database().ref(pageCommentKey);
		commentBase.on('child_added', function(childSnapshot) {
			let commentHtml = _createOneComment(childSnapshot.val());
			comments.prepend(commentHtml);

			counter++;
			commentCounter.text(counter);
		});

		$("#new-comment-btn").on('click', evt => {
			if (!curUser) {
				_popupSignIn();
			}
			else {
				_popupNewComment();
			}
		});
	}

	firebase.initializeApp(JSON.parse(atob(bstr)));
	curUser = firebase.auth().currentUser;
	firebase.auth().onAuthStateChanged(function(user) {
		if (user) {
			curUser = user;// User is signed in.
		} else {
			curUser = null;// No user is signed in.
		}
	});

	setTimeout(function() {
		_readSetHitCounter();
		_readHandleLikeCounter();
		_readHandleComments();
	}, 100);
}

module.exports = {
	init
};


// WEBPACK FOOTER //
// ./src/scripts/client/plugin/engage.js